import AssignmentOutlined from "@mui/icons-material/AssignmentOutlined";
import LockOutlined from "@mui/icons-material/LockOutlined";
import PersonOutline from "@mui/icons-material/PersonOutline";
import type React from "react";
import { useTranslation } from "src/design-system/core/TranslationContext";
import { useIntercom } from "src/hooks/useIntercom";
import { SideMenuAWithNavBarLayout } from "src/layouts/SideMenuWithNavBarLayout/SideMenuWithNavBarLayout";
import { ACCOUNT_LAYOUT_TK, ACCOUNT_TRANSLATION_NAMESPACE } from "src/views/account/config";
import { accountRoutes, useUserHasReportAccess } from "src/views/account/routes";

import type { NavBarSection } from "../SharedLayout/NavBar";

interface AccountLayoutProps {
    children?: React.ReactNode;
}

export function AccountLayout({ children }: AccountLayoutProps): JSX.Element {
    useIntercom();

    const hasReportAccess = useUserHasReportAccess();

    const { t } = useTranslation(`${ACCOUNT_TRANSLATION_NAMESPACE}:${ACCOUNT_LAYOUT_TK}`);
    const sections: NavBarSection[] = [
        {
            items: [
                {
                    title: t("profile"),
                    icon: PersonOutline,
                    href: accountRoutes.profileView(),
                },
                hasReportAccess && {
                    title: t("reports"),
                    icon: AssignmentOutlined,
                    href: accountRoutes.reportsView(),
                },
                {
                    title: t("password"),
                    icon: LockOutlined,
                    href: accountRoutes.passwordView(),
                },
            ].filter(Boolean),
        },
    ];
    return <SideMenuAWithNavBarLayout sections={sections}>{children}</SideMenuAWithNavBarLayout>;
}
